import WidgetKeyboardsContainer from 'components/WidgetKeyboards/WidgetKeyboardsContainer'
import WidgetKeyboardsPresentation from 'components/WidgetKeyboards/WidgetKeyboardsPresentation'

export default {
  Container: WidgetKeyboardsContainer,
  Presentation: WidgetKeyboardsPresentation,
}
